@if (teamMembers$ | async; as teamMembers) {
<div class="container">
  <div class="header">
    <div>
      <h3>Members</h3>
      <p>{{ teamMembers.length }} members</p>
    </div>
    <div class="add-btn">
      <button class="iconf-btn-blank" (click)="addMember()">
        <mat-icon>add_circle</mat-icon>
        add members
      </button>
    </div>
  </div>
  <app-search-edit-members [isReadOnly]="true" [hideHeader]="true" [teamMembers]="teamMembers"></app-search-edit-members>
</div>
}
